import React, { useContext, useCallback } from "react";
import {} from "bodycodi/cmap/app/js/common";

import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";
import PickerHeader from "bodycodi/cmap/app/components/common/pickerHeader";

import icon_flag from "bodycodi/cmap/app/img/icon_flag.png";

import Drawer from "@material-ui/core/Drawer";

const Info = () => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);

  const setOpen = (open: boolean) => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "CENTER_MNGT_INFO_POP",
      open: { centerMngtInfoPop: open },
    });
  };

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <Drawer
      anchor="bottom"
      open={state.centerMngtInfoPop}
      onClose={handleClose}
      className="picker-pop auto"
    >
      <PickerHeader title="연동센터 관리" onClose={handleClose} />
      <div className="picker-body center-mngt-pop">
        <div className="center-mngt-pop-title">
          <img src={icon_flag} />주 이용센터란?
        </div>
        <ul>
          <li>
            <div>&#183;</div>
            <div>연동중인 센터가 여러 개 있는 경우, 주 이용센터를 설정할 수 있습니다.</div>
          </li>
          <li>
            <div>&#183;</div>
            <div>
              주 이용센터로 설정하면, 앱 실행 시 <span>커뮤니티, 회원관리</span> 메뉴에서{" "}
              <span>기본 지정 센터</span>로 나타납니다.
            </div>
          </li>
        </ul>
      </div>
    </Drawer>
  );
};

export default Info;
